import React, { useEffect, useState } from "react"
import CookieConsent from "react-cookie-consent"

export const COOKIE_NAME = "gatsbyCookieConsent"

const CookieBanner = ({ onAccept, onDecline }) => {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  // react-cookie-consent reads browser cookies while rendering. Waiting until
  // after hydration keeps Gatsby's server HTML and first client render equal.
  if (!hasMounted) return null

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      cookieName={COOKIE_NAME}
      style={{ background: "#2B373B" }}
      buttonStyle={{
        background: "linear-gradient(90deg, #ff69b4, #add8e6, #dda0dd)",
        backgroundSize: "300% 300%",
        border: "none",
        borderRadius: "65px",
        color: "#202020",
        fontFamily: "Poppins, sans-serif",
        padding: "10px 18px",
        cursor: "pointer",
        fontSize: "1rem",
        position: "relative",
        zIndex: "10",
        fontWeight: "500",
        display: "inline-block",
        animation: "gradientAnimation 10s ease infinite",
      }}
      declineButtonStyle={{
        borderRadius: "65px",
        backgroundColor: "transparent",
        border: "2px solid white",
        fontFamily: "Poppins, sans-serif",
        color: "white",
        padding: "8px 16px",
        fontSize: "1rem",
        cursor: "pointer",
      }}
      enableDeclineButton
      expires={150}
      onAccept={onAccept}
      onDecline={onDecline}
    >
      We use cookies to improve your experience. By using this site, you accept
      our use of cookies.
    </CookieConsent>
  )
}

export default CookieBanner
